import React from "react";
import { Heart } from "lucide-react";

// ===== Constants =====
const BADGE_LABEL = "Shout Out"; // Text displayed inside the badge

/*
 * - Displays a small badge with a heart icon and text.
 */
const ShoutOutBadge: React.FC = () => {
    return (
            <span className="inline-flex items-center gap-1 bg-gradient-to-r from-orange-400 to-orange-600 text-white text-sm font-semibold px-3 py-1 rounded-full shadow-md whitespace-nowrap">
                {/* Heart Icon */}
                <Heart className="w-4 h-4 stroke-white fill-transparent" strokeWidth={2} />

                {/* Badge Label */}
                {BADGE_LABEL}
            </span>
        
    );
};

export default ShoutOutBadge;
